import React, { useEffect, useState, useContext, useRef, useImperativeHandle } from "react";
import { Link, useLocation } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import api from "services/api";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";

import Tooltip from "@mui/material/Tooltip";
import Pagination from "@mui/material/Pagination";

import SuiBadge from "components/SuiBadge";
import SuiTypography from "components/SuiTypography";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiBox from "components/SuiBox";
import SuiAvatar from "components/SuiAvatar";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { capitalCase } from "capital-case";
import { AccountContext } from "context/account";
import CategoryContext from "context/category-context";

import Prompt from "components/UpStyled/Prompt";
import toast from "react-hot-toast";
import moment from "moment";
import qs from "query-string";
import { useForm, Controller } from "react-hook-form";
import { DatePicker, Empty } from "antd";
import UTreeSelect from "components/UpStyled/UTreeSelect";

import { filterParser, sortParser } from "utils/helper";
import { stylesSortOptions, seasonOptions } from "utils/data";
import {
  canResizeImageUrl,
  getStyleImages,
  getFileImage,
  getOnLineTechPackImages,
} from "utils/imageHelper";

import StyleCard3 from "components/UpStyled/StyleCard3";
import StyleCard2 from "components/UpStyled/StyleCard2";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

const ImportStylePicturesModal = React.forwardRef(
  (
    { visible, handleClose, handleOk, handleRefresh = () => {}, isMulti = true },
    //if product not null, then it is edit mode
    ref
  ) => {
    const [data, setData] = useState({ hits: [], nbHits: 0, estimatedTotalHits: 0 });
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [searchStr, setSearchStr] = useState("");
    const [filterObj, setFilterObj] = useState({});
    const [collectionOptions, setCollectionOptions] = useState([]);
    const [selectedStyle, setSelectedStyle] = useState({});
    const [selectedImgs, setSelectedImgs] = useState([]);

    const [selectedStyleImgs, setSelectedStyleImgs] = useState([]);
    const [loading, setLoading] = useState(false);

    const {
      tree,
      actions: { findNodeByID, findParents },
    } = useContext(CategoryContext);
    //const metaFilesKey = ["imageFiles", "techPacksFiles", "referenceFiles"];
    const metaFilesKey = ["imageFiles"];

    useImperativeHandle(
      ref,
      () => ({
        selectedStyle,
        setSelectedStyle,
      }),
      [selectedStyle]
    );

    const {
      register,
      handleSubmit,
      trigger,
      setValue,
      watch,
      getValues,
      reset,
      formState: { errors },
      control,
    } = useForm();

    useEffect(() => {
      if (visible) {
        retrieveCollections();
      }
      reset({ sort_by: stylesSortOptions[0] });
    }, [visible, data]);

    useEffect(() => {
      if (visible) {
        const offset = pageSize * (page - 1);
        const limit = pageSize;
        let filter = {};
        retrieveStyles(offset, limit, "", filter);
      }
    }, [visible]);

    const retrieveStyles = async (offset = 0, limit = pageSize, q = "", filter = {}) => {
      const payload = { offset, limit };
      if (q) {
        payload["q"] = q;
      }
      //let myFilter = { collection_id: null };
      //allow user import styles which is already in a collection
      //if already in a style, we will first duplicate it and then import the duplicated one to the collection
      let myFilter = {};

      if (Object.keys(filter).length > 0) {
        myFilter = { ...myFilter, ...filter };
      }

      //get sorting options from form values
      const sortOpt = getValues("sort_by");
      let sortStr = "";

      if (sortOpt && sortOpt.value) {
        sortStr = sortParser(sortOpt.value);
      }

      myFilter = {
        ...myFilter,
      };

      const newFilterStr = filterParser(myFilter);

      if (newFilterStr) {
        payload["filter"] = newFilterStr;
        setFilterObj(myFilter);
      }
      if (sortStr) {
        payload["sort"] = [sortStr];
      }
      try {
        //const { data } = await api.project.list({ owner_id: user.id });
        setLoading(true);
        const { data } = await api.products.searchStyles(payload);

        setData(data ? data : { hits: [], nbHits: 0 });
        setLoading(false);
      } catch (err) {
        console.log(err);
        setLoading(false);
      }
    };

    const retrieveCollections = async () => {
      try {
        const { data } = await api.collections.list({ order: "-updated_at" });

        const collections = data["collections"] ? data["collections"] : [];
        const options = collections.map((x) => ({ label: x.title, value: x.id }));
        setCollectionOptions(options);
      } catch (err) {
        console.log(err);
      }
    };

    const handleApply = (data) => {
      const offset = pageSize * (page - 1);
      const limit = pageSize;
      setSearchStr(data["keywords"]);
      let myFilter = {};

      //category filter
      if (data["category"]) {
        myFilter["categories"] = data["category"];
      }
      //season filter
      if (data["season"] && data["season"]?.value) {
        myFilter["style_season"] = data["season"].value;
      }
      //collection filter
      if (data["collection"] && data["collection"]?.value) {
        myFilter["collection_id"] = data["collection"].value;
      }

      //year filter
      if (data["year"]) {
        let formatYearValue = moment(data["year"]).format("YYYY");
        myFilter["style_year"] = formatYearValue;
      }

      retrieveStyles(offset, limit, data["keywords"], myFilter);
    };

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
      const offset = pageSize * (newPage - 1);
      const limit = pageSize;
      retrieveStyles(offset, limit, searchStr, filterObj);
    };

    const handleChangeRowsPerPage = (option) => {
      const newPageSize = parseInt(option.value, 10);
      setPageSize(newPageSize);
      setPage(1);
      const offset = 0;
      const limit = newPageSize;
      retrieveStyles(offset, limit, searchStr, filterObj);
    };

    const totalNumber = data.nbHits ? data.nbHits : data.estimatedTotalHits;
    const pageCount = parseInt(Math.ceil(totalNumber / pageSize), 10);
    const pageOptions = [];
    for (let i = 0; i < pageCount; i++) {
      pageOptions.push(i);
    }
    const entriesStart = pageSize * (page - 1) + 1;
    const entriesEnd = pageSize * page > totalNumber ? totalNumber : pageSize * page;

    const handleCheckStyle = (p) => {
      setSelectedStyle(p);
    };

    const handleSelectStyle = (u, img) => {
      handleCheckStyle(u);
      let styleImages = getStyleImages(u, false, metaFilesKey);
      styleImages = styleImages.filter((f) => f?.type && f.type.includes("image")); //remove pdf format
      if (styleImages.length > 0) {
        let index = 0;

        if (img) {
          const findIndex = styleImages.findIndex((x) => x?.url == img?.url);
          if (findIndex >= 0) {
            index = findIndex;
          }
        }
        setSelectedImgs([styleImages[index]]); //default select first image
      }
      setSelectedStyleImgs(styleImages);
    };

    const handleBack = () => {
      setSelectedStyle({});
      setSelectedImgs([]);
    };

    // if (data?.hits?.length == 0 || loading) {
    //   return <div />;
    // }

    return (
      <Dialog
        open={visible}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xl"
      >
        <DialogTitle id="alert-dialog-title">
          Import your style images to post
          <IconButton
            aria-label="close"
            onClick={() => handleClose()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <SuiBox display={selectedStyle?.id ? "none" : "block"}>
            <SuiBox component="form" pb={3} onSubmit={handleSubmit(handleApply)}>
              <SuiBox
                display="flex"
                alignItems="flex-start"
                justifyContent="space-between"
                sx={{ width: "100%" }}
              >
                <SuiBox display="flex" alignItems="center" sx={{ gap: 1.5, flexWrap: "wrap" }}>
                  <SuiTypography variant="button" color="dark" fontWeight="regular">
                    Filter by:
                  </SuiTypography>
                  <div style={{ width: 100 }}>
                    <Controller
                      name="year"
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                          {...field}
                          picker="year"
                          placeholder="Year"
                          style={{
                            height: 40,
                            width: "100%",
                            borderRadius: "8px",
                            border: "1px solid #d2d6da",
                          }}
                          popupStyle={{
                            maxHeight: 400,

                            overflow: "auto",
                            zIndex: 9999,
                          }}
                        />
                      )}
                    />
                  </div>
                  <div style={{ width: 140 }}>
                    <Controller
                      name="collection"
                      control={control}
                      render={({ field }) => (
                        <SuiSelect
                          {...field}
                          options={collectionOptions}
                          placeholder="Collection"
                          backspaceRemovesValue
                          isClearable
                        />
                      )}
                    />
                  </div>
                  <div style={{ width: 140 }}>
                    <Controller
                      name="season"
                      control={control}
                      render={({ field }) => (
                        <SuiSelect
                          {...field}
                          options={seasonOptions}
                          placeholder="Season"
                          backspaceRemovesValue
                          isClearable
                        />
                      )}
                    />
                  </div>
                  <div style={{ minWidth: 210 }}>
                    <Controller
                      control={control}
                      name="category"
                      render={({ field: { onChange, onBlur, value, name, ref } }) => (
                        <UTreeSelect
                          tree={tree}
                          fieldNames={{ label: "label", value: "id", children: "children" }}
                          onChange={(e) => {
                            onChange(e);
                          }}
                          allowClear={true}
                          value={value}
                          placeholder="Category"
                        />
                      )}
                    />
                  </div>
                  <div style={{ width: 145 }}>
                    <Controller
                      name="sort_by"
                      control={control}
                      render={({ field }) => (
                        <SuiSelect
                          {...field}
                          options={stylesSortOptions}
                          placeholder="Sort By"
                          backspaceRemovesValue
                        />
                      )}
                    />
                  </div>
                  <SuiBox>
                    <SuiInput placeholder="Keywords" type="text" {...register("keywords")} />
                  </SuiBox>
                  <div>
                    <SuiButton variant="gradient" color="dark" type="submit">
                      Apply
                    </SuiButton>
                  </div>
                </SuiBox>
              </SuiBox>
            </SuiBox>
            {data.hits && data.hits.length > 0 ? (
              <SuiBox justifyContent="flex-start" display="flex" sx={{ flexWrap: "wrap" }}>
                {data.hits.map((u, index) => {
                  return (
                    <SuiBox key={index}>
                      <StyleCard3
                        product={u}
                        size="md"
                        isSelected={selectedStyle?.id == u.id}
                        handleSelectStyle={() => handleSelectStyle(u)}
                        metaFilesKey={metaFilesKey}
                      />
                    </SuiBox>
                  );
                })}
              </SuiBox>
            ) : (
              <Empty />
            )}
            <SuiBox
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems={{ xs: "flex-start", sm: "center" }}
              p={3}
            >
              <SuiBox display="flex" alignItems="center">
                <SuiBox mb={{ xs: 3, sm: 0 }}>
                  <SuiTypography variant="button" color="secondary" fontWeight="regular">
                    Showing {entriesStart} to {entriesEnd} of {totalNumber} entries
                  </SuiTypography>
                </SuiBox>

                <SuiBox display="flex" alignItems="center" gap={1}>
                  <SuiSelect
                    defaultValue={{ value: pageSize, label: pageSize }}
                    options={[10, 20, 50].map((entry) => ({ value: entry, label: entry }))}
                    onChange={handleChangeRowsPerPage}
                    size="small"
                  />

                  <SuiTypography variant="caption" color="secondary">
                    entries per page
                  </SuiTypography>
                </SuiBox>
              </SuiBox>
              <Pagination
                variant={"outlined"}
                color={"info"}
                count={pageOptions.length}
                defaultPage={page}
                onChange={handleChangePage}
              />
            </SuiBox>
          </SuiBox>
          {selectedStyle.id ? (
            <SuiBox>
              <SuiButton sx={{ float: "left" }} variant="text" color={"dark"} onClick={handleBack}>
                <ArrowBackIcon fontSize="md" /> Back to styles
              </SuiButton>

              <SuiBox display="flex" px={2} gap={8} alignItems="flex-start" justifyContent="center">
                <SuiBox
                  sx={{ width: 200, maxHeight: 400, overflow: "auto", flexWrap: "wrap" }}
                  display="flex"
                  alignItems="flex-start"
                  gap={1}
                >
                  {selectedStyleImgs.map((img) => {
                    const findIndex = selectedImgs.findIndex((x) => x.url == img.url);

                    return (
                      <SuiBox
                        sx={{
                          cursor: "pointer",
                          border: ({ borders }) =>
                            findIndex != -1
                              ? "2px solid #141414"
                              : `2px solid ${borders.borderColor}`,
                          height: 104,
                          width: 84,
                        }}
                        onClick={(e) => {
                          if (isMulti) {
                            if (findIndex == -1) {
                              setSelectedImgs([...selectedImgs, img]);
                            } else {
                              const newImages = [...selectedImgs];

                              newImages.splice(findIndex, 1);
                              setSelectedImgs(newImages);
                            }
                          } else {
                            setSelectedImgs([img]);
                          }
                        }}
                        position="relative"
                      >
                        <ImageCardWrapper
                          data={img}
                          mode={"icon"}
                          width={80}
                          height={100}
                          borderRadius="none"
                          pdfPagination={false}
                        />
                        <SuiBox
                          position="absolute"
                          top={4}
                          right={4}
                          display={findIndex != -1 ? "inline" : "none"}
                        >
                          <CheckCircleIcon color={"success"} fontSize="sm" />
                        </SuiBox>
                      </SuiBox>
                    );
                  })}
                </SuiBox>
                <SuiBox>
                  <ImageCardWrapper
                    data={selectedImgs.length > 0 ? selectedImgs[selectedImgs.length - 1] : {}}
                    mode={"icon"}
                    width={320}
                    height={400}
                    borderRadius="none"
                    pdfPagination={false}
                  />
                </SuiBox>
              </SuiBox>
            </SuiBox>
          ) : null}
        </DialogContent>
        <DialogActions>
          <SuiButton
            variant="gradient"
            size="medium"
            onClick={selectedStyle?.id ? handleBack : handleClose}
            color="light"
          >
            {selectedStyle?.id ? "Back" : "Cancel"}
          </SuiButton>
          <SuiButton
            size="medium"
            variant="gradient"
            color="dark"
            disabled={!(selectedStyle.id && selectedImgs.length > 0)}
            onClick={handleOk ? () => handleOk(selectedStyle, selectedImgs) : null}
          >
            {"Add"}
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  }
);

export default ImportStylePicturesModal;
